import { PaymentAttribution } from 'core/enums/payment-type';
import { PaymentRequestRedirectResponse } from 'core/services/api/payment/payment-dpp';
import { PayAtExternalResponse } from 'core/services/api/payment/payment-pay-at-link';
import { SubscriptionService } from 'core/services/api/subscriptions';
import { NumberUtils } from 'utils/number.utils';
import { PaymentRequestType } from './payment-request';
import { PayAtRedirectResolution, PayAtRedirectResponse } from './payment-request-pay-at';

export class PaymentRequestMomentCheckout implements PaymentRequestType<PayAtExternalResponse> {

  get hasSubscriptionDetails() {
    return (
      !!this.request.smartCardNumber
    );
  }

  constructor(private request: any) { }

  getDependantValues() {
    const { customerNumber, countryName, smartCardNumber } = this.request;

    return Promise.all(
      [
        !this.hasSubscriptionDetails ? SubscriptionService.getSubscriptions(customerNumber, countryName) : Promise.resolve(),
      ]
    )
      .then(
        ([subscriptions]) => {

          if (subscriptions?.subscriptions) {
            const subscription = smartCardNumber
              ? {
                smartcardNumber: smartCardNumber,
                services: []
              }
              : subscriptions.subscriptions.find(sub => sub.isPrimarySc);

            this.addValues({
              smartcardNumber: `${subscription?.smartcardNumber}`,
            })
          }

          return this;
        }
      );
  }

  addValues(values: { [key: string]: number | string | undefined }) {
    this.request = {
      ...this.request,
      ...values
    }
    return this;
  }

  toPaymentRequestObject() {
    return {countryCode: '',...this.request};
  }

  toTokenRequestObject() {
    const { customerNumber, amount, accountNumber, location, paymentAttribution } = this.request;
    const amountNumber = +`${amount}`;
    const amountInCents = isNaN(amountNumber) ? 0 : NumberUtils.FormatToDecimal(amountNumber * 100, '0-0', '');
    return {
      accountNumber: customerNumber,
      amount: `${amountInCents}`,
      customerId: customerNumber,
      customerRedirectUrl: location,
      clientReference: `${accountNumber}-${customerNumber}-ZA`,
      qrTags: [`jid=${paymentAttribution}`],
    };
  }

  handleResponse(response: any, paymentAttribution?: PaymentAttribution): Promise<PayAtRedirectResolution | boolean> {
    // TODO: improve conditional type logic
    if (Object.prototype.hasOwnProperty?.call(response, 'redirectUrl') && response?.target !== "_blank") {
      const res = response as PaymentRequestRedirectResponse;
      window.location.replace(res.redirectUrl);
      return Promise.resolve(false)
    }

    window.open(response.redirectUrl, response.target);
    return Promise.resolve(true);
  }
}